import {
  Routes,
  Route,
} from 'react-router-dom';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { ROUTES } from '../constant';

import Login from "../components/auth/login/login";
import SignUp from '../components/auth/sign_up/signUp';
import ForgotPassword from '../components/auth/forgotPassword/forgotPassword';
import ResetPassword from '../components/auth/resetPassword/resetPassword';
import ChangePassword from '../components/changePassword/changePassword';

import { loadData } from "../utils/localStorage";
import Profile from "../components/profile/profile";
import EditProfile from '../components/editProfile/editProfile';
import StudentNotes from '../components/studentNotes/studentNotes';
import AcademicCourses from "../components/academicCourses/academicCourses";
import StudentDashboard from "../components/studentDashboard/studentDashboard";
import AcademicDetailCourse from '../components/academicDetailCourse/academicDetailCourse';
import AcademicLessonDetails from "../components/academicLessonDetails/academicLessonDetails";
import CreateStudentProfile from '../components/createStudentProfile/createStudentProfile';

import NEFestPaymentSuccess from '../components/nef2023/nefPaymentSuccess/nefPaymentSuccess';
import NEFestSubmissions from '../components/nef2023/nefSubmission/nefSubmission';

import IITBombayTechfest from '../components/companyEvents/iitBombayTechfest/iitBombayTechfest';
import IITBombayTechfestCertificate from '../components/companyEvents/iitBombayTechfestCertificate/iitBombayTechfestCertificate';
import IITBombayTechfestListing from '../components/companyEvents/iitBombayTechfestListing/iitBombayTechfestListing';

import AdminDashbaord from '../components/schoolAdmin/adminDashboard/adminDashboard';

import StudentList from '../components/schoolAdmin/studentsList/adminStudentsList';
import AttendanceList from "../components/schoolAdmin/attendanceList/attendanceList";

import AdminProfile from "../components/schoolAdmin/adminProfile/adminProfile";
import EditAdminProfile from '../components/schoolAdmin/editAdminProfile/editAdminProfile';

import TeacherList from '../components/schoolAdmin/teacherList/teacherList';
import AddTeacher from '../components/schoolAdmin/addTeacher/addTeacher';

import CurriculumList from '../components/schoolAdmin/curriculumList/curriculumList';

import AdminChangePassword from '../components/schoolAdmin/adminChangePassword/adminChangePassword';

import BooksHomePage from '../components/bookSelling/booksHomePage/booksHomePage';
import BookDetailsPage from '../components/bookSelling/bookDetailPage/booksDetailsPage';
import BookCartPage from '../components/bookSelling/bookCartPage/bookCartPage';
import BookPaymentPage from '../components/bookSelling/bookCheckoutPage/bookCheckoutPage';
import BookDashboardList from '../components/bookSelling/bookDashboardListing/bookDashboardList';
import BookDashboardDetails from '../components/bookSelling/bookDashboardDetailsPage/bookDashboardDetails';
import BookLessonReaderPage from '../components/bookSelling/bookLessonReaderPage/bookLessonReaderPage';


function App() {
  const accessToken = loadData("access");
  const user = JSON.parse(loadData("user"));

  return (
    <Routes>
      <Route exact path={ROUTES.LOGIN} element={<Login />}></Route>
      <Route exact path={ROUTES.SIGN_UP} element={<SignUp />}></Route>
      <Route exact path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />}></Route>
      <Route exact path={ROUTES.RESET_PASSWORD + "/:otp/:email"} element={<ResetPassword />}></Route>

      <Route exact path={ROUTES.NEF_PAYMENT_LISTING} element={<NEFestPaymentSuccess />}></Route>
      <Route exact path={ROUTES.NEF_SUBMISSION} element={<NEFestSubmissions />}></Route>

      <Route exact path={ROUTES.IIT_BOMBAY_TECHFEST_SUBMISSION} element={<IITBombayTechfest />}></Route>
      <Route exact path={ROUTES.IIT_BOMBAY_TECHFEST_CERTIFICATE} element={<IITBombayTechfestCertificate />}></Route>
      <Route exact path={ROUTES.IIT_BOMBAY_TECHFEST_LISTING} element={<IITBombayTechfestListing />}></Route>

      {/* Books Selling Routes */}
      <Route exact path={ROUTES.BOOKS_SELLING_HOME_PAGE} element={<BooksHomePage />}></Route>
      <Route exact path={ROUTES.BOOKS_SELLING_DETAILS_PAGE + "/:slug"} element={<BookDetailsPage />}></Route>

      {
        accessToken != null
          &&
          <>
          <Route exact path={ROUTES.BOOKS_SELLING_CART_PAGE} element={<BookCartPage />}></Route>
          <Route exact path={ROUTES.BOOKS_SELLING_CHECKOUT_PAGE} element={<BookPaymentPage />}></Route>
          <Route exact path={ROUTES.BOOKS_SELLING_BOOK_DASHBOARD} element={<BookDashboardList />}></Route>
          <Route exact path={ROUTES.BOOKS_SELLING_BOOK_DASHBOARD_DETAILS + "/:slug"} element={<BookDashboardDetails />}></Route>
          <Route exact path={ROUTES.BOOKS_LESSON_READER + "/:slug/:lessonId"} element={<BookLessonReaderPage />}></Route>
          </>
      }

      {
        accessToken != null
          &&
          !(user?.role_permission.role_type.indexOf("SCHOOL") > -1)
          ?
          user.is_profile_created
            ?
            <>
              <Route exact path={ROUTES.DASHBOARD} element={<StudentDashboard />}></Route>
              <Route exact path={ROUTES.ACADEMIC_COURSES} element={<AcademicCourses />}></Route>
              <Route exact path={ROUTES.ACADEMIC_COURSE_DETAIL + "/:slug"} element={<AcademicDetailCourse />}></Route>
              <Route exact path={ROUTES.ACADEMIC_COURSE_DETAIL + "/:slug/lesson/:lessonSlug"} element={<AcademicLessonDetails />}></Route>
              <Route exact path={ROUTES.PROFILE} element={<Profile />}></Route>
              <Route exact path={ROUTES.CHANGE_PASSWORD} element={<ChangePassword />}></Route>
              <Route exact path={ROUTES.EDIT_PROFILE} element={<EditProfile />}></Route>
              <Route exact path={ROUTES.STUDENT_NOTES} element={<StudentNotes />}></Route>
            </>
            :
            <>
              <Route exact path={ROUTES.CREATE_STUDENT_PROFILE} element={<CreateStudentProfile />}></Route>
            </>
          :
          <>
            <Route exact path={ROUTES.ADMIN_DASHBOARD} element={<AdminDashbaord />}></Route>
            <Route exact path={ROUTES.ADMIN_STUDENTS} element={<StudentList />}></Route>
            <Route exact path={ROUTES.ADMIN_ATTENDANCE} element={<AttendanceList />}></Route>
            <Route exact path={ROUTES.ADMIN_TEACHERS} element={<TeacherList />}></Route>
            <Route exact path={ROUTES.ADMIN_ADD_TEACHERS} element={<AddTeacher />}></Route>
            <Route exact path={ROUTES.ADMIN_CURRICULUM_LIST} element={<CurriculumList />}></Route>
            <Route exact path={ROUTES.ADMIN_PROFILE} element={<AdminProfile />}></Route>
            <Route exact path={ROUTES.ADMIN_EDIT_PROFILE} element={<EditAdminProfile />}></Route>
            <Route exact path={ROUTES.ADMIN_CHANGE_PASSWORD} element={<AdminChangePassword />}></Route>
          </>
      }
      <Route path="*" element={<Login />} />
    </Routes>
  );
}

export default App;
